
<template>
  <div>
    <v-btn v-if="btn_kind == 'btn'" @click="dialog=true" color="primary" round small ><v-icon small left>mdi-pencil</v-icon>retornado</v-btn>
    <v-btn v-if="btn_kind == 'icon'" @click="dialog=true" color="primary" icon small class="mx-0 my-1" ><v-icon >mdi-pencil</v-icon></v-btn>
    <v-btn v-if="btn_kind == 'fab'" @click="dialog=true" color="primary" fab small ><v-icon small>mdi-pencil</v-icon></v-btn>

    <v-dialog v-model="dialog" v-if="dialog" persistent max-width="900px" transition="dialog-transition">
      <v-card v-if="dialog" style="border-radius: 8px">
        <v-card-title primary-title>
          <div class="headline mb-0">Editando cheque retornado</div>
        </v-card-title>
        <v-divider></v-divider>
        <v-card-text>
          <card-loading-transparent v-if="loading"></card-loading-transparent>
          <template v-if="!loading">
            <v-form ref='returned' lazy-validation>
              <v-autocomplete 
                v-if="kind == 'to_confirm' && can_edit" 
                prepend-icon="mdi-account" 
                label="Cliente" 
                :items="all_clients" 
                :item-text="formatClientDisplayName" 
                item-value="id" 
                v-model="returned.client_id" 
                :rules="[rules.required]"
                :filter="filterClients"
              >
                <template v-slot:selection="{item}">
                  <v-sheet width="100%" class="d-flex flex-column justify-start mt-2">
                    <span> {{ formatClientDisplayName(item) }} <span v-if="item.fantasyName">({{ item.fantasyName }})</span> </span>
                    <div class="d-flex justify-space-between mt-1 align-center">
                      <span class="caption">ID: {{item.id}}</span>
                      <span class="caption">Cidade: {{ item.city }} </span>
                    </div>
                  </v-sheet>
                </template>
                <template v-slot:item="{ item }">
                  <v-list-item-content>
                    <v-list-item-title class="pb-1"> Nome/Rz social: <b> {{ formatClientDisplayName(item) }} </b> </v-list-item-title>
                    <v-list-item-subtitle class="mb-1" v-if="item.fantasyName && item.fantasyName != item.name">Nome fantasia: <b> {{item.fantasyName}} </b></v-list-item-subtitle>
                    <v-list-item-subtitle class="d-flex justify-space-between">
                      <div>ID: <b>{{ item.id }} </b> </div>
                      <div>Cidade: <b>{{ item.city }}</b></div>
                    </v-list-item-subtitle>
                  </v-list-item-content>
                </template>
              </v-autocomplete>
              <v-text-field v-model="returned.number" prepend-icon="mdi-information" label="Número" v-mask="'######'" :rules="[rules.required, rules.ck_number]"></v-text-field>
              <v-text-field v-model="returned.motive" prepend-icon="mdi-information" label="Código do Motivo" :rules="[rules.motive]" v-mask="'##'"></v-text-field>
              <v-text-field v-if="kind == 'to_confirm' && can_edit" v-model="returned.value_aux" v-currency="currency" prepend-icon="mdi-currency-brl" label="Valor" :rules="[rules.notZero]"></v-text-field>
              <v-textarea v-model="returned.comment" prepend-icon="mdi-message-reply" rows="3" label="Comentário"></v-textarea>
            </v-form>
          </template>
          <template v-if="loading">
            <v-progress-linear color='white' :indeterminate="true"></v-progress-linear>
          </template>
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions class="justify-end">
          <f-btn @click="close()" cancel></f-btn>
          <f-btn @click="saveReturned()" save></f-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import Api from '@/api/index';
import {CurrencyDirective} from 'vue-currency-input'
import clientDisplay from '@/mixins/clientDisplay'

export default {
  name: "DialogEditReturned",
  mixins: [clientDisplay],
  directives: {currency: CurrencyDirective,},
  props: {
    check: {
      type: Object,
    },
    btn_kind: {
      type: String,
      default: 'icon' , // icon, btn, fab
    },
    kind: {
      type: String,
      default: 'to_confirm' , // to_confirm, in_hands, concluded
    }
  },
  data() {
    return {
      currency:{
        currency: null,
        locale: 'en-EN',
        autoDecimalMode: true,
        decimalLength: 2,
        distractionFree:false,
      },

      saving: false,
      loading_clients: false,

      all_clients: [],

      dialog: false,
      returned: {
        client_id: null,
        number: null,
        motive: null,
        value_aux: '0.00',
        comment: null,
      },
      rules: {
        required: v => !!v || 'Campo é necessário',
        ck_number: v => !!v && v.length == 6 || 'Deve ter 6 dígitos. Ex: 000123',
        notZeroPercentage: v => (!!v && v != '0.00' && parseFloat(v) < 100) || 'Formato válido: "99.99"',
        notZero: v=> v != '0.00' || 'Não pode ser zero',
        motive: v => !!v && (v >= 10 && v <= 99) || 'Deve ser entre 10 e 99',
      },
    }
  },
  methods: {
    getClients(){
      this.loading_clients = true
      Api.Client.index({modality_id: this.activeModalityId, short: true}).then(r=>r.data).then(d=>{
        d = d.data? d.data.map(c=>c.attributes) : d
        this.all_clients = [...d]
        this.loading_clients = false
      })
    },
    filterClients (item, queryText, itemText) {
      const name = item.name ? item.name.toLowerCase() : ''
      const corporate_name = item.corporateName ? item.corporateName.toLowerCase() : ''
      const fantasyName = item.fantasyName ? item.fantasyName.toLowerCase() : ''
      const city = item.city ? item.city.toLowerCase() : ''
      const id = item.id ? item.id.toString() : ''
      const searchText = queryText.toLowerCase()

      return name.indexOf(searchText) > -1 || corporate_name.indexOf(searchText) > -1 || fantasyName.indexOf(searchText) > -1 || city.indexOf(searchText) > -1 || id.indexOf(searchText) > -1
    },
    setupReturned(is_null = false){
      this.ready = false
      if (is_null){
        this.returned.client_id = null
        this.returned.number = null
        this.returned.motive = null
        this.returned.value_aux = '0.00'
        this.returned.comment = null
      } else {
        let {id, client_id, number, motive, value, comment} = this.check
        this.returned.id = id
        this.returned.client_id = client_id
        this.returned.number = number
        this.returned.motive = motive
        this.returned.value_aux = value
        this.returned.comment = comment
      }
      this.ready = true
    },
    saveReturned(){
      if (this.$refs.returned.validate()){
        this.saving = true
        let {value_aux, client_id, ...r} = this.returned
        let obj = {
          ...r,
        }
        if (this.kind == 'to_confirm'){
          obj.value = value_aux.replace(/,/g, '')
          obj.client_id = client_id
        }
        Api.ReturnedCheck.update(obj).then(r=>r.data).then(d=>{
          this.successUpdated()
          this.dialog = false
          this.$emit('doneUpdate', d)
        }).catch((err) => {
          console.log({err});
        }).finally(()=>{
          this.saving = false
        })
      }
    },
    close(){
      this.dialog = false
    },
  },
  computed: {
    loading(){
      return this.loading_clients || this.saving
    },
    is_seller() {
      return this.isSeller()
    },
    can_edit(){
      let can = true
      if (this.returned.id){
        if (this.check.check_id || this.deposit_id){
          can = false 
        }
      }
      return can
    },
    allClients_computed(){
      if (this.allClients){
        return this.allClients.map(obj=>obj.attributes)
      }
      return null
    },
  },
  watch: {
    dialog(nv,ov) {
      if (nv){
        if (this.kind == 'to_confirm' && this.can_edit){
          this.getClients();
        }
        this.setupReturned()
      } else if (nv == false){
        this.setupReturned(true)
      }
    }
  },
}
</script>